import AuthAPI from '../api/auth';
import BaseActionCableConnector from '../../shared/helpers/BaseActionCableConnector';
import DashboardAudioNotificationHelper from './AudioAlerts/DashboardAudioNotificationHelper';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { emitter } from 'shared/helpers/mitt';
import { useImpersonation } from 'dashboard/composables/useImpersonation';

const { isImpersonating } = useImpersonation();

// Lista de números bloqueados (adicione quantos quiser)
const IGNORED_PHONES = ['+556292309777', '+5562888888888'];

class ActionCableConnector extends BaseActionCableConnector {
  constructor(app, pubsubToken) {
    const { websocketURL = '' } = window.chatwootConfig || {};
    super(app, pubsubToken, websocketURL);
    this.CancelTyping = [];
    this.events = {
      'message.created': this.onMessageCreated,
      'message.updated': this.onMessageUpdated,
      'conversation.created': this.onConversationCreated,
      'conversation.status_changed': this.onStatusChange,
      'user:logout': this.onLogout,
      'page:reload': this.onReload,
      'assignee.changed': this.onAssigneeChanged,
      'conversation.typing_on': this.onTypingOn,
      'conversation.typing_off': this.onTypingOff,
      'conversation.contact_changed': this.onConversationContactChange,
      'presence.update': this.onPresenceUpdate,
      'contact.deleted': this.onContactDelete,
      'contact.updated': this.onContactUpdate,
      'conversation.mentioned': this.onConversationMentioned,
      'notification.created': this.onNotificationCreated,
      'notification.deleted': this.onNotificationDeleted,
      'notification.updated': this.onNotificationUpdated,
      'conversation.read': this.onConversationRead,
      'conversation.updated': this.onConversationUpdated,
      'account.cache_invalidated': this.onCacheInvalidate,
      'copilot.message.created': this.onCopilotMessageCreated,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  onReconnect = () => {
    emitter.emit(BUS_EVENTS.WEBSOCKET_RECONNECT);
  };

  // eslint-disable-next-line class-methods-use-this
  onDisconnected = () => {
    emitter.emit(BUS_EVENTS.WEBSOCKET_DISCONNECT);
  };

  onMessageUpdated = data => {
    this.app.$store.dispatch('updateMessage', data);
  };

  onPresenceUpdate = data => {
    if (isImpersonating.value) return;
    this.app.$store.dispatch('contacts/updatePresence', data.contacts);
    this.app.$store.dispatch('agents/updatePresence', data.users);
    this.app.$store.dispatch('setCurrentUserAvailability', data.users);
  };

  onConversationContactChange = payload => {
    const { meta = {}, id: conversationId } = payload;
    const { sender } = meta || {};
    if (conversationId) {
      this.app.$store.dispatch('updateConversationContact', {
        conversationId,
        ...sender,
      });
    }
  };

  onAssigneeChanged = payload => {
    const { id } = payload;
    if (id) {
      this.app.$store.dispatch('updateConversation', payload);
    }
    this.fetchConversationStats();
  };




onConversationCreated = (data) => {

  // Verifica número ignorado
  const senderPhone = data.meta?.sender?.phone_number?.trim() || '';
  if (IGNORED_PHONES.includes(senderPhone)) return;

  console.log('Nova conversa iniciada:', data);

  // Verifica se há mensagens e se a primeira tem template_params
  const hasTemplateParams =
    data.messages &&
    data.messages.length > 0 &&
    data.messages[0].additional_attributes &&
    data.messages[0].additional_attributes.template_params;

  if (hasTemplateParams) {
    console.log('Mensagem via template detectada. Notificação ignorada.');
    return;
  }

  const accountId = data.account_id;
  const conversationId = data.id;
  const inboxId = data.inbox_id;

  const messageBody = data.meta?.sender?.name
    ? `Nova conversa com ${data.meta.sender.name}`
    : `Conversa Id ${conversationId}`;

  const notificationUrl = `/app/accounts/${accountId}/inbox/${inboxId}/conversations/${conversationId}`;

  const shouldNotify =
    document.visibilityState === 'hidden' && Notification.permission === 'granted';

  if (shouldNotify) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification('Nova conversa iniciada', {
        body: messageBody,
        tag: `conversation-${conversationId}`,
        data: { url: notificationUrl }
      });
    });
  }
};



  onConversationRead = data => {
    this.app.$store.dispatch('updateConversation', data);
  };

  // eslint-disable-next-line class-methods-use-this
  onLogout = () => AuthAPI.logout();





onMessageCreated = (data) => {
  // === Funções auxiliares de filtragem ===
  const isFromAgent = (msg) => (msg.sender_type || '').toLowerCase() === 'user';

  const isResolutionMessage = (msg) =>
    msg.message_type === 2 &&
    msg.content?.toLowerCase().includes('marcada como resolvida');

  const isAssignmentMessage = (msg) =>
    msg.content?.toLowerCase().includes('atribuiu a si mesmo');

  // === Ignorar mensagens irrelevantes ===
  if (isFromAgent(data) || isResolutionMessage(data) || isAssignmentMessage(data)) {
    return;
  }

  console.log('Nova mensagem criada:', data);

  // === Extrair dados relevantes ===
  const {
    conversation: { last_activity_at: lastActivityAt },
    conversation_id: conversationId,
    sender,
    account_id: accountId,
    inbox_id: inboxId,
  } = data;

  // === Ações da aplicação ===
  DashboardAudioNotificationHelper.onNewMessage(data);
  this.app.$store.dispatch('addMessage', data);
  this.app.$store.dispatch('updateConversationLastActivity', {
    lastActivityAt,
    conversationId,
  });

 // === Ignora notificação para alguns números ===
const phoneIgnored = sender?.phone_number || '';

if (IGNORED_PHONES.includes(phoneIgnored.trim())) {
  return; // ou apenas pule o bloco de notificação
}

  // === Notificação push ===
  if ('serviceWorker' in navigator && 'Notification' in window) {
    const notificationUrl = `/app/accounts/${accountId}/inbox/${inboxId}/conversations/${conversationId}`;
    const notificationTag = `conversation-${conversationId}`;

    const contactName = sender?.name || 'Contato desconhecido';
    const phone = sender?.phone_number || 'Número não informado';

    if (phone.trim() !== '') {
      const notificationTitle = contactName;
      const notificationBody = `Telefone: ${phone}`;

      const showNotification = (registration) => {
        registration.showNotification(notificationTitle, {
          body: notificationBody,
          requireInteraction: true,
          tag: notificationTag,
          data: { url: notificationUrl }
        });
      };

      if (Notification.permission === 'granted') {
        navigator.serviceWorker.ready.then(showNotification);
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            navigator.serviceWorker.ready.then(showNotification);
          }
        });
      }
    }
  }
};







  // eslint-disable-next-line class-methods-use-this
  onReload = () => window.location.reload();

  onStatusChange = data => {
    this.app.$store.dispatch('updateConversation', data);
    this.fetchConversationStats();
  };

  onConversationUpdated = data => {
    this.app.$store.dispatch('updateConversation', data);
    this.fetchConversationStats();
  };

  onTypingOn = ({ conversation, user }) => {
    const conversationId = conversation.id;

    this.clearTimer(conversationId);
    this.app.$store.dispatch('conversationTypingStatus/create', {
      conversationId,
      user,
    });
    this.initTimer({ conversation, user });
  };

  onTypingOff = ({ conversation, user }) => {
    const conversationId = conversation.id;

    this.clearTimer(conversationId);
    this.app.$store.dispatch('conversationTypingStatus/destroy', {
      conversationId,
      user,
    });
  };

  onConversationMentioned = data => {
    this.app.$store.dispatch('addMentions', data);
  };

  clearTimer = conversationId => {
    const timerEvent = this.CancelTyping[conversationId];

    if (timerEvent) {
      clearTimeout(timerEvent);
      this.CancelTyping[conversationId] = null;
    }
  };

  initTimer = ({ conversation, user }) => {
    const conversationId = conversation.id;
    // Turn off typing automatically after 30 seconds
    this.CancelTyping[conversationId] = setTimeout(() => {
      this.onTypingOff({ conversation, user });
    }, 30000);
  };

  // eslint-disable-next-line class-methods-use-this
  fetchConversationStats = () => {
    emitter.emit('fetch_conversation_stats');
  };

  onContactDelete = data => {
    this.app.$store.dispatch(
      'contacts/deleteContactThroughConversations',
      data.id
    );
    this.fetchConversationStats();
  };

  onContactUpdate = data => {
    this.app.$store.dispatch('contacts/updateContact', data);
  };

  onNotificationCreated = data => {
    this.app.$store.dispatch('notifications/addNotification', data);
  };

  onNotificationDeleted = data => {
    this.app.$store.dispatch('notifications/deleteNotification', data);
  };

  onNotificationUpdated = data => {
    this.app.$store.dispatch('notifications/updateNotification', data);
  };

  onCopilotMessageCreated = data => {
    this.app.$store.dispatch('copilotMessages/upsert', data);
  };

  onCacheInvalidate = data => {
    const keys = data.cache_keys;
    this.app.$store.dispatch('labels/revalidate', { newKey: keys.label });
    this.app.$store.dispatch('inboxes/revalidate', { newKey: keys.inbox });
    this.app.$store.dispatch('teams/revalidate', { newKey: keys.team });
  };
}

export default {
  init(store, pubsubToken) {
    return new ActionCableConnector({ $store: store }, pubsubToken);
  },
};
